<template>
  <span>
    <span v-b-tooltip.hover :title="tipoStatus.title" :class="`badge badge-${tipoStatus.class}`">
      <font-awesome-icon v-if="!!tipoStatus.icon" :icon="`fa-solid fa-${tipoStatus.icon}`" />
      <span>{{ tipoStatus.title }}</span>
    </span>
  </span>
</template>

<script>
export default {
  props: ['value', 'type'],
  computed: {
    tipoStatus() {
      const tipos = {
        range: (value) =>
          this.$util.stringToNumber(value) > 0
            ? { title: value, class: 'success', icon: null }
            : this.$util.stringToNumber(value) < 0 && { title: value, class: 'danger', icon: null },
        default: (value) => ({ title: value, class: 'primary', icon: null })
      };
      const render = tipos[this.type || 'default'];
      return render(this.value);
    }
  }
};
</script>

<style lang="scss" scoped></style>
